import styled from 'styled-components'
import { P as PKS } from 'konsys-ui'

export const Div = styled.div`
  position: absolute;
  top: -9px;
`

export const a = styled.div`
`

export const P = styled(PKS)`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`
